import { atom } from "recoil"

export const AtomLog = atom({
    key:'ATOMLOG',
    default:''
})
  